export default __webpack_public_path__ + "static/media/Text_Format_Italic_ENG.afd56ae7.svg";